import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    jobInfo:{},
     loading: false,
   }),
   getters: {
    jobInfo(state){
     return state.jobInfo;
    },
    loading(state) {
       return state.loading;
     }
   },
 
   mutations: {
     setJobInfo(state, payload) {
       state.jobInfo = payload;
     },
   },
 
   actions: {
     async getJobInfo(context,payload){
       context.state.loading = true;
       await api.get(ep.info_jobs(payload.id)).then((res) => {
         context.commit("setJobInfo", res.data.data);
         context.state.loading = false;
       });
     }
   },
}